import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

//永久路由 
export const constantRouterMap = [{
        path: '/login',
        component: () => import('@/views/login/login'),
        hidden: true
    }, {
        path: '/home',
        component: () => import('@/views/login/home'), 
        hidden: true
    }, {
        path: '/unreach',
        component: () => import('@/views/login/unreach'),
        hidden: true
    }, {
        path: '/pwd',
        component: () => import('@/views/info/pwd'),
        hidden: true
    }, {
        path: '/treat_token',
        component: () => import('@/views/license/treat_token'),
        hidden: true
    }, {
        path: '/edges',
        component: () => import('@/views/edge/edges'),
        hidden: true
    }, {
        path: '/all_edges',
        component: () => import('@/views/edge/all_edges'),
        hidden: true
    }, {
        path: '/edge_exp',
        component: () => import('@/views/edge/edge_exp'),
        hidden: true
    }, {
        path: '/serials',
        component: () => import('@/views/edge/serials'),
        hidden: true
    }, {
        path: '/pcs',
        component: () => import('@/views/edge/pcs'),
        hidden: true
    }, {
        path: '/hospitals',
        component: () => import('@/views/info/hospitals'),
        hidden: true
    }, {
        path: '/lic_upload',
        component: () => import('@/views/license/upload'),
        hidden: true
    }, {
        path: '/licenses',
        component: () => import('@/views/license/licenses'),
        hidden: true
    }, {
        path: '/license_apply',
        component: () => import('@/views/license/license_apply'),
        hidden: true
    }, {
        path: '/applies',
        component: () => import('@/views/license/applies'),
        hidden: true
    }, {
        path: '/applies_done',
        component: () => import('@/views/license/applies_done'),
        hidden: true
    }, {
        path: '/lic_notice',
        component: () => import('@/views/license/license_apply_notice'),
        hidden: true
    }, {
        path: '/app_types',
        component: () => import('@/views/info/app_types'),
        hidden: true
    }, {
        path: '/agents',
        component: () => import('@/views/info/agents'),
        hidden: true
    }, {
        path: '/logs',
        component: () => import('@/views/info/logs'),
        hidden: true
    }, {
        path: '/task_run',
        component: () => import('@/views/task/task_run'),
        hidden: true
    }, {
        path: '/tool_kit',
        component: () => import('@/views/task/tool_kit'),
        hidden: true
    }, {
        path: '/batch',
        component: () => import('@/views/task/batch'),
        hidden: true
    }, {
        path: '/batch_list',
        component: () => import('@/views/task/batch_list'),
        hidden: true
    }, {
        path: '/iq_list',
        component: () => import('@/views/task/iq_list'),
        hidden: true
    }, {
        path: '/exp_report_all',
        component: () => import('@/views/finance/exp_report_all'),
        hidden: true
    }, {
        path: '/exp_report_detail',
        component: () => import('@/views/finance/exp_report_detail'),
        hidden: true
    }, {
        path: '/expense_apply',
        component: () => import('@/views/finance/expense_apply'),
        hidden: true
    }, {
        path: '/expense_done',
        component: () => import('@/views/finance/expense_done'),
        hidden: true
    }, {
        path: '/expense_person',
        component: () => import('@/views/finance/expense_person'),
        hidden: true
    }, {
        path: '/expense_ready',
        component: () => import('@/views/finance/expense_ready'),
        hidden: true
    }, {
        path: '/expense_reject',
        component: () => import('@/views/finance/expense_reject'),
        hidden: true
    }, {
        path: '/expense_wait',
        component: () => import('@/views/finance/expense_wait'),
        hidden: true
    }, {
        path: '/jump',
        component: () => import('@/views/media/jump'),
        hidden: true
    }, {
        path: '/demo_upload_login',
        component: () => import('@/views/task/demo_upload_login'),
        hidden: true
    }, {
        path: '/demo_upload_history',
        component: () => import('@/views/task/demo_upload_history'),
        hidden: true
    }, {
        path: '/demo_upload',
        component: () => import('@/views/task/demo_upload'),
        hidden: true
    }, {
        path: '/check_config',
        component: () => import('@/views/task/check_config'),
        hidden: true
    }, {
        path: '/lic_generate',
        component: () => import('@/views/license/license_generate'),
        hidden: true
    }, {
        path: '/ai_files',
        component: () => import('@/views/ai/files'),
        hidden: true
    }]
    
//路由
export default new Router({
    routes: constantRouterMap
})
